import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ExhibitionistStrip from '../../../widgets/ExhibitionistStrip';
import SubmissionDetails from '../../../SubmissionDetails';
import DeviationGruserLoader from '../_partials/DeviationGruserLoader/DeviationGruserLoader';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export const DefaultDetails = ({ deviation, className, contentClassName })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviation_gruser_flag = useFlag('deviation_gruser');
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-block'],
        "data-hook": BiDataHook.DEVIATION_META
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        showTitle: true
    })), isExtendedLoaded && /*#__PURE__*/ React.createElement(ExtendedDetails, {
        deviation: deviation
    }), deviation_gruser_flag && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DeviationGruserLoader, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Zone, {
        type: "topLeft",
        mapModuleTypeToWidgetConfig: {
            exhibitionist: {
                viewComponent: ExhibitionistStrip
            }
        }
    })));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
